"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * remove 0x from a hex string
 * @param hex
 */

function rm0x(hex) {
  return hex.startsWith('0x') ? hex.slice(2) : hex;
}

exports.rm0x = rm0x;
/**
 * parse to hex string
 * @param x
 */

function toHex(x) {
  if (typeof x === 'string') {
    if (x.startsWith('0x')) {
      return x;
    }

    return '0x' + x;
  }

  if (typeof x === 'number') {
    var hex = Number(x).toString(16);
    return hex.length % 2 === 1 ? '0x0' + hex : '0x' + hex;
  }

  return '0x' + x.toString('hex');
}

exports.toHex = toHex;
/**
 * parse a hex string to buffer
 * @param x
 */

function toBuffer(x) {
  return Buffer.from(rm0x(x), 'hex');
}

exports.toBuffer = toBuffer;